import { config, useTransition } from 'react-spring';

import { useIsInitialRender } from 'src/shared/hooks';

/**
 * Transition between two elements based on a boolean
 * toggle with a fade and vertical translation effect
 *
 * @param toggle determines which element is currently visible
 */
const useSlide = (toggle: boolean) => {
  const isInitialRender = useIsInitialRender();

  return useTransition(toggle, null, {
    config: config.stiff,
    immediate: isInitialRender,
    from: { opacity: 0, transform: 'translate3d(0, 100%, 0)' },
    enter: { opacity: 1, transform: 'translate3d(0, 0%, 0)' },
    leave: {
      opacity: 0,
      transform: `translate3d(0, ${toggle ? '' : '-'}50%, 0)`,
      position: 'absolute',
      width: '100%',
    },
  });
};

export { useSlide };
